<template>
  <div class="splash-navbar">
    <logout class="m-3" />
  </div>
</template>

<script>
import authService from "../../services/AuthService";
import Logout from "./Logout.vue";

export default {
  name: "LogoutHeader",
  components: {
    Logout,
  },
  methods: {
    logout() {
      this.$vs.loading();
      authService.logout();
      location.reload();
    },
  },
};
</script>

<style lang="scss">
.splash-navbar {
  position: fixed !important;
  top: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
</style>
